// extracted by mini-css-extract-plugin
module.exports = {"plus":"plus-3gwWO","minus":"minus-36OjN"};